'use client';

import { useEffect } from 'react';
import { setTitle } from '@/components/HtmlHead/utils';
import { useHtmlHeadState } from '../HtmlHeadProvider';

export interface StaticTitleProps {
    title?: string;
}

export function StaticTitle({ title }: StaticTitleProps) {
    const { registerBlurHandler, unregisterBlurHandler } = useHtmlHeadState();

    useEffect(() => {
        const blurHandler = () => {
            if (title) {
                setTitle(title);
            }

            return undefined;
        };
        registerBlurHandler(blurHandler);

        return () => {
            unregisterBlurHandler(blurHandler);
        };
    }, [registerBlurHandler, title, unregisterBlurHandler]);

    return null;
}
